module.exports = __webpack_public_path__ + "static/media/icb-sq.f5c2b5fa.jpg";